'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$() {
  this.aRp = null;
  this.aRG = null;
  this.aRs = null;
  this.aRt = false;
  this.aRy = null;
  this.aRz = false;
  this.aRE = null;
  this.aRF = false;
  this.aRq = null;
  this.aRr = false;
  this.aRC = null;
  this.aRD = false;
  this.aRA = null;
  this.aRB = false;
  this.aRu = null;
  this.aRv = false;
  this.aRw = null;
  this.aRx = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$ = this;
  this.aRp = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$();
  this.aRG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$.prototype = $p;
$p.eR = (function() {
  return this.aRp;
});
$p.eO = (function() {
  return this.aRG;
});
$p.bW = (function() {
  if ((!this.aRt)) {
    this.aRs = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aRt = true;
  }
  return this.aRs;
});
$p.b9 = (function() {
  if ((!this.aRz)) {
    this.aRy = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aRz = true;
  }
  return this.aRy;
});
$p.b3 = (function() {
  if ((!this.aRF)) {
    this.aRE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aRF = true;
  }
  return this.aRE;
});
$p.aG = (function() {
  if ((!this.aRr)) {
    this.aRq = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aRr = true;
  }
  return this.aRq;
});
$p.az = (function() {
  if ((!this.aRD)) {
    this.aRC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aRD = true;
  }
  return this.aRC;
});
$p.aY = (function() {
  if ((!this.aRB)) {
    this.aRA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aRB = true;
  }
  return this.aRA;
});
$p.Jj = (function() {
  if ((!this.aRv)) {
    this.aRu = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Shipping Marks";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aRv = true;
  }
  return this.aRu;
});
$p.bsm = (function() {
  if ((!this.aRx)) {
    this.aRw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aRx = true;
  }
  return this.aRw;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$, "app.data.data_point_types$package$ShippingMarksForm$", ({
  Gw: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$() {
  this.aRn = null;
  this.aRo = false;
  this.aRl = null;
  this.aRm = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$.prototype = $p;
$p.aA = (function() {
  if ((!this.aRo)) {
    this.aRn = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aRo = true;
  }
  return this.aRn;
});
$p.bs4 = (function() {
  if ((!this.aRm)) {
    this.aRl = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarksForm$().Jj();
    this.aRm = true;
  }
  return this.aRl;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$, "app.data.data_point_types$package$ShippingMarks$", ({
  Gv: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShippingMarks$ };
//# sourceMappingURL=app.data.data_point_types$package$-Shipping-Marks$.js.map
